import React, { useState, useEffect } from "react";
import "./questionModal.css";

const DetailsModal = ({ visible, onClose, onSubmit, current_ref = "", due_date = "", notes = "", pay = true }) => {
  const [ref, setRef] = useState(current_ref);
  const [dueDate, setDueDate] = useState(due_date);
  const [noteText, setNoteText] = useState(notes);

  // Helpers to safely handle <input type="date"> values (avoid UTC parsing quirks)
  const toInputValue = (d) => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  };
  const fromInputValue = (s) => {
    if (!s) return null;
    const [y, m, d] = s.split("-").map(Number);
    return new Date(y, m - 1, d);
  };

  // Next working day (skips Sat/Sun)
  const getNextWorkingDay = (baseDate) => {
    const d = new Date(baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate());
    do {
      d.setDate(d.getDate() + 1);
    } while (d.getDay() === 0 || d.getDay() === 6); // 0=Sun, 6=Sat
    return d;
  };

  const handleNextWorkingDay = () => {
    const base =  new Date();//fromInputValue(dueDate) ||
    const next = getNextWorkingDay(base);
    setDueDate(toInputValue(next));
  };

  // Reset form when modal opens
  useEffect(() => {
    if (visible) {
      setRef(current_ref);
      setDueDate(due_date);
      setNoteText(notes);
    }
  }, [visible, current_ref, due_date, notes]);

  if (!visible) return null;

  const handleSubmit = () => {
    onSubmit({
      current_ref: ref,
      due_date: dueDate,
      notes: noteText,
    });
  };

  return (
    <div className="modal_overlay">
      <div className="modal_content">
        <h3>Confirm details:</h3>

        <div className="form_group">
          <label>Reference / PO number:</label>
          <input
            type="text"
            value={ref}
            onChange={(e) => setRef(e.target.value)}
          />
        </div>
        
        <div className="form_group">
          <label>Required by Date:</label>
          <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
            <input
              type="date"
              value={dueDate}
              onChange={(e) => setDueDate(e.target.value)}
            />
            <button className="nwd button" type="button"  onClick={handleNextWorkingDay}>
              Next working day
            </button>
          </div>
        </div>

        <p>We will endeavor to achieve your delivery date; a team member will provide confirmation.</p>

        <div className="form_group">
          <label>Delivery notes:</label>
          <textarea
            rows="3"
            value={noteText}
            onChange={(e) => setNoteText(e.target.value)}
          />
        </div>

        <div className="modal_buttons">
          <button className="pay_button" onClick={handleSubmit}>
            {pay === true ? "Make Payment" : "Accept Quote"}
          </button>
          &nbsp;
          <button className="pay_button" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default DetailsModal;
